import isObject from '../utility/isObject';
import Product from "./product";

class OrderProduct {
  public static fragmentsFields(): string {
    return `
      productId
      count
    `;
  }

  public static fromJson(value: any): OrderProduct {
    if (!isObject(value)) {
      throw new TypeError('value must be an object for Product.fromJson(value).');
    }

    const productId = value['productId'];
    const count = value['count'];
    const price = value['price'];
    const taxPrice = value['taxPrice'];

    return new OrderProduct({
      productId,
      count,
      price,
      taxPrice,
    });
  }

  public static fromProduct(product: Product, count?: number): OrderProduct {
    const productId = product.id;
    const price = product.price;
    const taxPrice = product.taxPrice;

    return new OrderProduct({
      productId,
      count,
      price,
      taxPrice,
    });
  }

  public productId: string;
  public count: number;
  public price: number;
  public taxPrice: number;

  constructor({
    productId = '',
    count = 0,
    price = 0,
    taxPrice = 0,
  }: {
    productId?: string;
    count?: number;
    price?: number;
    taxPrice?: number;
  }) {
    this.productId = productId;
    this.count = count;
    this.price = price;
    this.taxPrice = taxPrice;
  }

  public toJson(): object {
    return {
      productId: this.productId,
      count: this.count,
    }
  }
}

export default OrderProduct;
